/**
 * As SEÇÕES de orçamento — a definição única, servidor e navegador.
 *
 * ## O que uma seção é
 *
 * A porta pela qual o pedido entrou. O cliente pediu duas telas próprias,
 * "igual à tela separada do Del Credere", e o del credere sabe se recortar
 * porque `DEL_CREDERE` é um **quadrante**: está em `quote.table_type_id`, uma
 * propriedade do ORÇAMENTO.
 *
 * Vinílico e rodapé não são quadrantes: são **classes de produto**, e classe é
 * propriedade do ITEM. A seção (`quote.segmento`) é o que dá ao orçamento a
 * dimensão que o quadrante já dava ao del credere.
 *
 * ## O que ela NÃO é
 *
 * Não é restrição de conteúdo. O del credere não trava classe — as quatro têm
 * preço nos três quadrantes —, e as seções novas espelham: a **busca** é
 * filtrada pela classe da seção, e nada bloqueia um item de outra. Travar
 * quebraria justamente os dois orçamentos reais que têm vinílico, porque os
 * dois têm cerâmica junto.
 *
 * ## Por que mora em `shared`
 *
 * O pareamento seção × classe é consumido pelo serviço (ao criar), pela rota
 * (ao validar), pela tela (ao montar menu e rota) e pela busca (ao filtrar).
 * Quatro cópias divergem na primeira mudança — foi assim que o pareamento do
 * Villa Arte passou meses mentindo.
 */
export const SEGMENTOS_ORCAMENTO = [
    {
        code: 'vinilico',
        classe: 'vinilico',
        rotulo: 'Vinílicos',
        rota: '/vinilicos',
        tabelaPadrao: 'RT10',
    },
    {
        code: 'rodape',
        classe: 'rodape',
        rotulo: 'Rodapé Engenharia',
        rota: '/rodape',
        tabelaPadrao: 'RT10',
    },
];
/** A seção pelo code, ou `undefined` quando o code não existe. */
export function segmentoPorCode(code) {
    if (code === null || code === undefined || code === '')
        return undefined;
    return SEGMENTOS_ORCAMENTO.find((s) => s.code === code);
}
/** Os codes válidos — alimenta o Zod da rota sem lista escrita à mão. */
export const CODES_SEGMENTO = SEGMENTOS_ORCAMENTO.map((s) => s.code);
//# sourceMappingURL=segmentos.js.map